var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cm-option', {disabled: _vm.disabled}]},[_c('div',{staticClass:"cm-option-icon"},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticClass:"cm-option-text"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }